import { render, staticRenderFns } from "./Greatness.vue?vue&type=template&id=262c7445&"
import script from "./Greatness.vue?vue&type=script&lang=js&"
export * from "./Greatness.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports